import { Box, Skeleton, Stack } from '@mui/material'
import React from 'react'

const DesktopCouponSectionShimmer: React.FC = () => (
    <Box sx={{ pb: '1rem' }}>
        <Stack direction="row" spacing={1.5} sx={{ overflowX: 'auto' }}>
            {[...Array(3)].map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        borderRadius: '12px',
                        px: 2,
                        py: 1.5,
                        bgcolor: 'rgb(236, 248, 244)',
                        flexShrink: 0,
                        minWidth: 'fit-content',
                        gap: 1.5,
                        mr: 1
                    }}
                >
                    <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1.5 }} />
                    <Box sx={{ flex: 1 }}>
                        <Skeleton variant="text" width={120} height={14} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width={60} height={18} sx={{ mb: 0.5 }} />
                    </Box>
                </Box>
            ))}
        </Stack>
    </Box>
)

export default DesktopCouponSectionShimmer
